import React from "react";
import { Col, Row } from "react-bootstrap";

import {
  SiJupyter,
  SiPycharm,
  SiVisualstudiocode,
  SiDocker
} from "react-icons/si";
import { FaCode, FaWind } from "react-icons/fa"; // substitutes for Cursor and Windsurf
import { GiBrain } from "react-icons/gi"; // substitute for Ollama
import { MdChatBubbleOutline } from "react-icons/md"; // substitute for Jan

const tools = [
  { icon: <SiPycharm />, name: "PyCharm" },
  { icon: <SiVisualstudiocode />, name: "VS Code" },
  { icon: <SiJupyter />, name: "Jupyter Notebook" },
  { icon: <SiDocker />, name: "Docker" },
  { icon: <FaCode />, name: "Cursor" },
  { icon: <FaWind />, name: "Windsurf" },
  { icon: <GiBrain />, name: "Ollama" },
  { icon: <MdChatBubbleOutline />, name: "Jan" },
];

function Toolstack() {
  return (
    <>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        {tools.map((tool, idx) => (
          <Col
            xs={4}
            md={2}
            className="tech-icons"
            key={idx}
            style={{ textAlign: "center" }}
          >
            {tool.icon}
            <div style={{ fontSize: "0.8rem", marginTop: "5px" }}>
              {tool.name}
            </div>
          </Col>
        ))}
      </Row>
    </>
  );
}

export default Toolstack;
